import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/** Public client configuration served by GET /api/config. */
export interface AppConfig {
  iceServers: RTCIceServer[];
  maxImageMb: number;
  maxVideoMb: number;
  /** Origin of the developer portal (our own subdomain). */
  developerPortalUrl: string;
  docsUrl: string;
  /** Sign-up needs an emailed invite. */
  inviteOnly: boolean;
}

export const useAppConfig = () =>
  useQuery({
    queryKey: ["config"],
    queryFn: () => api.get<AppConfig>("/api/config"),
    staleTime: Infinity,
  });
